import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-privacy-en',
  templateUrl: './privacy-en.component.html',
  styleUrls: ['./privacy-en.component.css']
})
export class PrivacyEnComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
